/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Lead_TimeInputs */

const vi_carrier_form_lead_time = /** @type {(inputs: Carrier_Form_Lead_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dự kiến`)
};

/**

* @param {Carrier_Form_Lead_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_lead_time = /** @type {((inputs?: Carrier_Form_Lead_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Lead_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_lead_time(inputs)
});